module.exports = __webpack_public_path__ + "static/media/160307-MobileKickoff-Recap.001.f7a3962a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/misc/160307-MobileKickoff-Recap/160307-MobileKickoff-Recap.001.png
// module id = 176
// module chunks = 0